import React, { useEffect } from "react";
import "./CumpleanosNotificacion.css";

const CumpleanosNotificacion = ({
  esCumpleanos,
  cumpleaneros = [],
  nombreUsuario,
  onClose,
}) => {
  useEffect(() => {
    document.body.classList.add("modal-open");
    return () => document.body.classList.remove("modal-open");
  }, []);

  // Si es mi cumpleaños
  if (esCumpleanos) {
    return (
      <div className="cumpleanos-overlay" onClick={onClose}>
        <div
          className="cumpleanos-popup cumpleanos-popup--propio"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="cumpleanos-confetti" aria-hidden="true" />
          <button
            className="cumpleanos-cerrar"
            onClick={onClose}
            aria-label="Cerrar"
          >
            ×
          </button>

          <div className="cumpleanos-icono-principal" aria-hidden="true">
            <span className="material-icons">cake</span>
          </div>

          <h3 className="cumpleanos-titulo cumpleanos-titulo--propio">
            ¡Feliz Cumpleaños!
          </h3>

          <p className="cumpleanos-mensaje">
            Hoy es tu día especial,{" "}
            <span className="cumpleanos-nombre-destacado">{nombreUsuario}</span>
            . El equipo de DARPHA Fire Solutions te desea un maravilloso
            cumpleaños.
          </p>

          <button
            className="cumpleanos-btn cumpleanos-btn--propio"
            onClick={onClose}
          >
            <span className="material-icons" style={{ fontSize: "18px" }}>
              celebration
            </span>
            ¡Gracias!
          </button>
        </div>
      </div>
    );
  }

  // Si hay otros cumpleañeros
  if (cumpleaneros && cumpleaneros.length > 0) {
    return (
      <div className="cumpleanos-overlay" onClick={onClose}>
        <div
          className="cumpleanos-popup cumpleanos-popup--otros"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            className="cumpleanos-cerrar"
            onClick={onClose}
            aria-label="Cerrar"
          >
            ×
          </button>

          <div
            className="cumpleanos-icono-principal cumpleanos-icono-principal--otros"
            aria-hidden="true"
          >
            <span className="material-icons">celebration</span>
          </div>

          <h3 className="cumpleanos-titulo">
            {cumpleaneros.length === 1
              ? "¡Hoy hay un cumpleaños!"
              : `¡Hoy hay ${cumpleaneros.length} cumpleaños!`}
          </h3>

          <p className="cumpleanos-subtitulo">
            {cumpleaneros.length === 1
              ? "No olvides felicitar a:"
              : "No olvides felicitar a tus compañeros:"}
          </p>

          <ul className="cumpleanos-lista">
            {cumpleaneros.map((persona, index) => (
              <li key={index} className="cumpleanos-lista-item">
                <span
                  className="material-icons cumpleanos-lista-icono"
                  aria-hidden="true"
                >
                  cake
                </span>
                <span className="cumpleanos-lista-nombre">
                  {persona.nombreusuario}
                </span>
              </li>
            ))}
          </ul>

          <button className="cumpleanos-btn" onClick={onClose}>
            ¡Entendido!
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default CumpleanosNotificacion;
